// extracted by mini-css-extract-plugin
export var banner = "_i3-0";
export var closeButton = "_i3-2";
export var greenCheckmark = "_i3-3";
export var hereLink = "_i3-4";
export var titleIcon = "_i3-1";